import { Box, IconButton } from "@mui/material";

const toggleButtonStyle = {
  width: 135,
  fontSize: "18px",
  fontWeight: 600,
  transition: "color 0.3s ease-in-out, background-color 0.3s ease-in-out",
  "&:hover": {
    backgroundColor: "transparent !important",
  },
  padding: "0px",
};

export default function TogglePerAcreSelector({ isPerAcre, setIsPerAcre }) {
  return (
    <Box
      sx={{
        position: "relative",
        width: 280,
        height: 50,
        backgroundColor: "transparent",
        borderRadius: "999px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "4px",
        boxSizing: "border-box",
        border: "2px solid var(--mui-palette-primary-main)",
        "[data-mui-color-scheme='dark'] &": {
          border: "2px solid var(--mui-palette-primary-light)",
        },
        "@media (max-width:600px)": {
          marginLeft: "0px !important",
        },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 2,
          left: isPerAcre === 0 ? 2 : "calc(50%)",
          width: isPerAcre === 0 ? "calc(50% + 2px)" : "calc(50% - 2px)",
          height: "calc(100% - 4px) !important",
          borderRadius: "999px !important",
          transition: "left 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
          boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)",
          zIndex: 1,
          backgroundColor: "primary.main",
          "[data-mui-color-scheme='dark'] &": {
            backgroundColor: "primary.light",
          },
        }}
      />

      <Box
        sx={{
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
          position: "relative",
          zIndex: 2,
        }}
      >
        <IconButton
          onClick={() => setIsPerAcre(0)}
          sx={{
            ...toggleButtonStyle,
            color: isPerAcre === 0 ? "secondary.contrastText" : "primary.main",
            "[data-mui-color-scheme='dark'] &": {
              color: isPerAcre === 0 ? "secondary.contrastText" : "primary.light",
            },
          }}
        >
          Totals
        </IconButton>

        <IconButton
          onClick={() => setIsPerAcre(1)}
          sx={{
            ...toggleButtonStyle,
            color: isPerAcre === 1 ? "secondary.contrastText" : "primary.main",
            "[data-mui-color-scheme='dark'] &": {
              color: isPerAcre === 1 ? "secondary.contrastText" : "primary.light",
            },
          }}
        >
          Per Acre
        </IconButton>
      </Box>
    </Box>
  );
}
